<template>
  <div class="dialog-wrap">
    <el-dialog title="用户信息"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="close()"
               @open="open()"
               top="20px"
               width="1200px">
      <div class="senioBox">
        <div class="seniorItem">
          <div class="invite">
            <span class="blue"></span>
            <p>基础信息</p>
          </div>
          <div class="edit"
               @click="handleEdit()">编辑</div>
          <el-form ref="userForm"
                   label-width="80px"
                   class="userForm"
                   style="marginLeft:-30px;">
            <el-form-item label="头像"
                          prop="avatar">
              <el-upload class="avatar-uploader"
                         :action="imgUploadUrl"
                         :headers="uploadHeaders"
                         :show-file-list="false"
                         :on-success="handleUploadSuccess"
                         :before-upload="handleBeforeUpload">
                <img v-if="senior.avatar"
                     :src="senior.avatar"
                     style="width:40px;height:40px">
                <i v-else
                   class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <!-- <el-form-item label="头像">
              <el-avatar :src="senior.avatar"></el-avatar>
            </el-form-item> -->
            <el-form-item label="姓名">
              <el-input v-model="senior.realname"
                        :disabled="disabled"
                        clearable></el-input>
            </el-form-item>
            <el-form-item label="昵称">
              <el-input v-model="senior.nickname"
                        :disabled="disabled"
                        clearable></el-input>
            </el-form-item>
            <el-form-item label="性别">
              <el-radio-group v-model="senior.gender"
                              :disabled="disabled">
                <el-radio :label="1">学长</el-radio>
                <el-radio :label="2">学姐</el-radio>
                <el-radio :label="0">未知</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="个人简介">
              <el-input v-model="senior.additional"
                        clearable
                        autosize
                        type="textarea"
                        :disabled="disabled"></el-input>
            </el-form-item>

          </el-form>
          <div class="invite">
            <span class="blue"></span>
            <p>录取信息</p>
          </div>
          <el-form ref="userForm"
                   label-width="100px"
                   class="userForm"
                   style="marginLeft:-50px;">
            <el-form-item label="录取年份">
              <el-select v-model="senior.recruit_year"
                         filterable
                         collapse-tags
                         :disabled="disabled"
                         placeholder="请选择"
                         style="width: 270px">
                <el-option v-for="(item, index) in  filter.year"
                           :key="index"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="录取院校">
              <el-select v-model="senior.recruit_college_code"
                         filterable
                         collapse-tags
                         :disabled="disabled"
                         placeholder="请选择"
                         style="width: 270px"
                         @change="collegeChange">
                <el-option v-for="(item, index) in $store.state.collegeList"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="录取专业">
              <el-select v-model="senior.recruit_major_code"
                         filterable
                         collapse-tags
                         :disabled="disabled"
                         placeholder="请选择"
                         style="width: 270px"
                         @change="majorChange">
                <el-option v-for="(item, index) in majorList"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                  <span>{{ `（${item.code}）${item.name}` }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="录取学院">
              <el-select v-model="senior.recruit_academy_code"
                         filterable
                         collapse-tags
                         :disabled="disabled"
                         placeholder="请选择"
                         style="width: 270px"
                         @change="academyChange">
                <el-option v-for="(item, index) in academyList"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                  <span>{{ `${item.name}` }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="研究方向">
              <el-select v-model="senior.recruit_direction_code"
                         filterable
                         collapse-tags
                         :disabled="disabled"
                         placeholder="请选择"
                         style="width: 270px"
                         @change="directionChange">
                <el-option v-for="(item, index) in directionList"
                           :key="index"
                           :label="item.direction"
                           :value="item.direction_code">
                  <span>{{ `${item.direction}` }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="初试总分：">
              <el-input v-model="senior.initial_test_score"
                        clearable
                        maxlength="4"
                        :disabled="disabled"
                        style="width: 270px"><template slot="append">分</template></el-input>
            </el-form-item>
            <el-form-item label="初试科目：">
              <el-select v-model="senior.test_subject_codes"
                         multiple
                         clearable
                         placeholder="请选择"
                         :disabled="disabled"
                         style="width: 270px"
                         @change="handleSubject">
                <el-option v-for="(item, index) in subjectsList"
                           :key="index"
                           :label="item.subject_name"
                           :value="item.subject_code">
                  <span>{{
                    `（${item.subject_code}）${item.subject_name}`
                  }}</span>
                </el-option>
              </el-select>
            </el-form-item>

          </el-form>

        </div>
        <div class="seniorItem">
          <el-form ref="userForm"
                   label-width="80px"
                   class="userForm"
                   style="marginLeft:10px;">
            <el-form-item label="科目分数：">
              <div v-for="(item,index) in scoreList"
                   :key="index"
                   :label="item.subjectName+'：'"
                   class="score">
                <div class="subjectName">{{item.subjectName}}</div>
                <el-input v-model="item.score"
                          border="none"
                          :disabled="disabled"
                          style="width:90px;height:100%"
                          class="inptScore"></el-input>
                <span class="preScore">分</span>
              </div>
            </el-form-item>
            <el-form-item label="录取类型：">
              <el-radio-group v-model="senior.recruit_type">
                <el-radio :label="1">一志愿</el-radio>
                <el-radio :label="2">调剂</el-radio>
              </el-radio-group>
            </el-form-item>
            <div class="invite"
                 style="marginLeft:10px">
              <span class="blue"></span>
              <p>身份信息</p>
            </div>
            <el-form-item label="荣誉称号："
                          style="marginTop:10px">
              <el-select v-model="honors"
                         multiple
                         clearable
                         :disabled="disabled"
                         placeholder="请选择"
                         style="width:270px">
                <el-option v-for="(item, index) in honorList"
                           :key="index"
                           :label="item.label"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="其他荣誉：">
              <el-input v-model="otherHonor"
                        :disabled="disabled"
                        autosize
                        type="textarea"
                        style="width:270px"></el-input>
            </el-form-item>
            <el-form-item label="身份证明：">
              <el-upload :action="imgUploadUrl"
                         :headers="uploadHeaders"
                         list-type="picture-card"
                         :on-preview="handlePictureCardPreview"
                         :on-remove="handleRemove"
                         :on-success="handleSuccess"
                         :file-list="fileList">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogImageVisible"
                         :append-to-body="true">
                <img width="100%"
                     :src="dialogImageUrl"
                     alt="">
              </el-dialog>
            </el-form-item>

            <el-form-item label="视频简介：">
              <video width="140px"
                     height="140px"
                     :src="senior.intro_video_url"
                     style="border:1px solid #DCDFE6"></video>
            </el-form-item>
          </el-form>

        </div>
        <div class="seniorItem"
             style="border:none">
          <el-form ref="userForm"
                   label-width="60px"
                   class="userForm"
                   style="marginLeft:10px;">

            <div class="invite"
                 style="marginLeft:10px;marginBottom:20px">
              <span class="blue"></span>
              <p>联系方式</p>
            </div>
            <el-form-item label="手机号">
              <el-input v-model="senior.mobile"
                        :disabled="disabled"
                        clearable></el-input>
            </el-form-item>
            <el-form-item label="微信号">
              <el-input v-model="senior.wechat"
                        :disabled="disabled"
                        clearable></el-input>
            </el-form-item>
            <el-form-item label="QQ号">
              <el-input v-model="senior.qq"
                        :disabled="disabled"
                        clearable></el-input>
            </el-form-item>

          </el-form>

          <div class="footer"
               v-if="!disabled">

            <div class="cancle"
                 @click="close()">取消</div>
            <div class="confirm"
                 @click="handleSubmit()">确认</div>

          </div>
        </div>

      </div>
    </el-dialog>
  </div>
</template>

<script>
import { seniorDetail, seniorUpdate } from '@/api/senior'
import { imgUploadUrl, uploadHeaders } from '@/config/index'
import {
  collegeMajorList,
  majorSubjectList,
  academyList,
  majorinfo,
} from '@/api/common'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rowDetail: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      honors: [],
      honorList: [
        {
          id: 0,
          label: '初试总分第一',
          ischeck: false,
        },
        {
          id: 1,
          label: '专业综合第一',
          ischeck: false,
        },
        {
          id: 2,
          label: '复试成绩第一',
          ischeck: false,
        },
        {
          id: 3,
          label: '跨考高分上岸',
          ischeck: false,
        },
        {
          id: 4,
          label: '逆袭上岸典范',
          ischeck: false,
        },
        {
          id: 5,
          label: '总分 400+',
          ischeck: false,
        },
        {
          id: 6,
          label: '数学 140+',
          ischeck: false,
        },
        {
          id: 7,
          label: '英语 80+',
          ischeck: false,
        },
        {
          id: 8,
          label: '政治 75+',
          ischeck: false,
        },
        {
          id: 9,
          label: '国家奖学金',
          ischeck: false,
        },
        {
          id: 10,
          label: '校级一等奖学金',
          ischeck: false,
        },
        {
          id: 11,
          label: '校级二等奖学金',
          ischeck: false,
        },
        {
          id: 12,
          label: '专项奖学金获得者',
          ischeck: false,
        },
        {
          id: 13,
          label: '学业优秀奖',
          ischeck: false,
        },
        {
          id: 14,
          label: '科研创新奖学金',
          ischeck: false,
        },

        {
          id: 15,
          label: '四级 600+',
          ischeck: false,
        },
        {
          id: 16,
          label: '六级 550+',
          ischeck: false,
        },
        {
          id: 17,
          label: '六级 600+',
          ischeck: false,
        },
        {
          id: 18,
          label: '雅思 7.0+',
          ischeck: false,
        },
        {
          id: 19,
          label: '托福 100+',
          ischeck: false,
        },
        {
          id: 20,
          label: '专四优秀',
          ischeck: false,
        },
        {
          id: 21,
          label: '专八通过',
          ischeck: false,
        },

        {
          id: 22,
          label: '校级科研项目参与',
          ischeck: false,
        },
        {
          id: 23,
          label: '省级竞赛获奖',
          ischeck: false,
        },
        {
          id: 24,
          label: '发表学术论文',
          ischeck: false,
        },
        {
          id: 25,
          label: '专利持有',
          ischeck: false,
        },
        {
          id: 26,
          label: '计算机二级证书',
          ischeck: false,
        },
        {
          id: 27,
          label: '教师资格证书',
          ischeck: false,
        },
        {
          id: 28,
          label: '实验室助理',
          ischeck: false,
        },

        {
          id: 29,
          label: '往届辅导上岸率 90%+',
          ischeck: false,
        },
        {
          id: 30,
          label: '1v1 辅导超百人次',
          ischeck: false,
        },
        {
          id: 31,
          label: '押中考研真题考点',
          ischeck: false,
        },
        {
          id: 32,
          label: '资料被千人收藏',
          ischeck: false,
        },
        {
          id: 33,
          label: '学员口碑五星好评',
          ischeck: false,
        },
        {
          id: 34,
          label: '高分学员孵化导师',
          ischeck: false,
        },
        {
          id: 35,
          label: '校级优秀毕业生',
          ischeck: false,
        },
        {
          id: 36,
          label: '三好学生标兵',
          ischeck: false,
        },
        {
          id: 37,
          label: '优秀学生干部',
          ischeck: false,
        },
        {
          id: 38,
          label: '社会实践先进个人',
          ischeck: false,
        },
        {
          id: 39,
          label: '志愿服务之星',
          ischeck: false,
        },
        {
          id: 40,
          label: '初试第一',
          ischeck: false,
        },
        {
          id: 41,
          label: '专业课第一',
          ischeck: false,
        },
        {
          id: 42,
          label: '总分第一',
          ischeck: false,
        },
      ],
      senior: {},
      filter: {
        year: [
          {
            label: '2024年',
            value: '2024',
          },
          {
            label: '2023年',
            value: '2023',
          },
          {
            label: '2022年',
            value: '2022',
          },
          {
            label: '2021年',
            value: '2021',
          },
          {
            label: '2020年',
            value: '2020',
          },
        ],
      },
      majorList: [],
      academyList: [],
      directionList: [],
      subjectsList: [],
      scoreList: [],
      honor: ['初试第一', '专业课第一', '总分第一'],
      otherHonor: [],
      disabled: true,
      dialogImageUrl: '',
      dialogImageVisible: false,
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      fileList: [],
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
  },
  methods: {
    handleSuccess(response, file, fileList) {
      this.fileList.push({
        url: response.data.url,
      })
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogImageVisible = true
    },
    handleRemove() {},
    handleEdit() {
      this.disabled = false
    },
    close() {
      this.disabled = true
      this.$emit('close')
    },
    open() {
      this.getDetail()
      this.$store.dispatch('getAllColleges')
    },

    getDetail() {
      seniorDetail({ uid: this.rowDetail.uid }).then((res) => {
        this.senior = res
        console.log('333', this.senior)
        if (this.senior.recruit_certify_img != null) {
          this.fileList = this.senior.recruit_certify_img
            .split(',')
            .map((v) => {
              return {
                url: v,
              }
            })
        }
        console.log(
          ' this.senior.test_subject_codes ',
          this.senior.test_subject_codes
        )
        this.senior.test_subject_codes =
          this.senior.test_subject_codes.split(',')
        this.scoreList = []
        this.senior.test_subject_names.split(',').map((item, index) => {
          this.senior.test_subject_scores.split(',').map((v, id) => {
            if (index == id) {
              this.scoreList.push({
                subjectName: item,
                score: v,
              })
            }
          })
        })
        this.scoreList.map((items, k) => {
          this.senior.test_subject_codes.map((p, i) => {
            if (k == i) {
              items.code = ''
              items.code = p
            }
          })
        })
        this.honors = []
        this.otherHonor = []
        console.log('55', this.senior)
        if (this.senior.honor_tags != '') {
          this.senior.honor_tags = this.senior.honor_tags.replace(/，/g, ',')

          this.senior.honor_tags.split(',').map((items, index) => {
            this.honorList.map((v, t) => {
              if (v.label == items) {
                this.honors.push(v.id)
              }
            })
          })

          let str = this.getContentAfterHash(this.senior.honor_tags)
          str.split(',').map((t) => {
            if (t != '') {
              this.otherHonor.push(t)
            }
            this.otherHonor.join(',')
          })
        }

        this.getMajor(this.senior.recruit_college_code)
        this.getAcademy(
          this.senior.recruit_college_code,
          this.senior.recruit_major_code
        )
        this.majorDirect(
          this.senior.recruit_college_code,
          this.senior.recruit_major_code
        )
        this.getSubjectsByMajorCode(
          this.senior.recruit_college_code,
          this.senior.recruit_major_code
        )
      })
    },
    // 提取#号后面内容的函数
    getContentAfterHash(str) {
      // 找到最后一个#的位置（处理多个#的情况，取最后一个#之后的内容）
      const hashIndex = str.lastIndexOf('#')

      // 如果找到#号，截取#之后的所有字符；没找到则返回空字符串
      if (hashIndex !== -1) {
        return str.slice(hashIndex + 1) // +1 是为了跳过#本身
      }

      return ''
    },
    handleUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.senior.avatar = res.data.url
      } else {
        this.$message.error(res.error)
      }
    },
    handleBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    handleSubmit() {
      this.formateSenior()
      // this.senior.test_subject_codes = this.senior.test_subject_codes.join(',')
      let query = {
        ...this.senior,
      }
      let score = []
      this.scoreList.map((item) => {
        score.push(item.score)
      })
      let honName = []
      this.honors.map((item) => {
        this.honorList.map((itemk) => {
          if (item == itemk.id) {
            honName.push(itemk.label)
          }
        })
      })
      query.honor_tags = honName.join(',') + ',' + '#' + this.otherHonor
      query.test_subject_scores = score.join(',')
      let arr = this.fileList.map((v) => {
        return v.url
      })
      query.recruit_certify_img = arr.join(',')
      seniorUpdate(query).then((res) => {
        this.close()
        this.$message.success(`修改成功`)
      })
    },
    collegeChange(e) {
      this.senior.recruit_major_code = ''
      this.senior.recruit_major_name = ''
      this.senior.recruit_academy_code = ''
      this.senior.recruit_academy_name = ''
      this.senior.test_subject_codes = ''
      this.senior.test_subject_names = ''
      this.senior.recruit_direction_code = ''
      this.senior.recruit_direction_name = ''
      this.senior.recruit_college_name = this.$store.state.collegeList.find(
        (item) => {
          return item.code === e //筛选出匹配数据
        }
      ).name
      this.getMajor(this.senior.recruit_college_code)
    },
    majorChange(e) {
      this.senior.test_subject_codes = ''
      this.senior.test_subject_names = ''
      this.senior.recruit_academy_code = ''
      this.senior.recruit_academy_name = ''
      this.senior.recruit_major_name = this.majorList.find((item) => {
        return item.code === e //筛选出匹配数据
      }).name
      this.getAcademy(
        this.senior.recruit_college_code,
        this.senior.recruit_major_code
      )
      this.majorDirect(
        this.senior.recruit_college_code,
        this.senior.recruit_major_code
      )
      this.getSubjectsByMajorCode(
        this.senior.recruit_college_code,
        this.senior.recruit_major_code
      )
    },
    academyChange(e) {
      this.senior.test_subject_codes = ''
      this.senior.test_subject_names = ''
      this.senior.recruit_academy_name = this.academyList.find((item) => {
        return item.code === e //筛选出匹配数据
      }).name
    },
    directionChange(e) {
      this.senior.recruit_direction_name = this.directionList.find((item) => {
        return item.direction_code === e //筛选出匹配数据
      }).direction
    },
    handleSubject(e, item) {
      let scorep = []

      this.subjectsList.map((item) => {
        e.map((v) => {
          if (item.subject_code == v) {
            scorep.push({
              subjectName: item.subject_name,
              score: 0,
              code: v,
            })
          }
        })
      })
      this.scoreList = scorep
    },
    //录取专业
    getMajor(college_code) {
      collegeMajorList({
        college_code: college_code,
        isPaging: 0,
      }).then((res) => {
        this.majorList = res.list || []
      })
    },
    //录取学院
    getAcademy(college_code, major_code) {
      academyList({
        college_code: college_code,
        isPaging: 0,
        major_code: major_code,
      }).then((res) => {
        this.academyList = res.list || []
      })
    },
    // 录取方向
    majorDirect(college_code, major_code) {
      majorinfo({
        isPaging: 0,
        college_code: college_code,
        major_code: major_code,
      }).then((res) => {
        if (res.academys && res.academys.length) {
          let list = res.academys.map((item) => item.directions).flat()
          let obj = {}
          for (let item of list) {
            if (!obj[item.direction_code]) {
              obj[item.direction_code] = item
            }
          }
          this.directionList = Object.values(obj)
        }
      })
    },
    // 考试科目
    getSubjectsByMajorCode(college_code, major_code) {
      let query = {
        isPaging: 0,
        college_code: college_code,
        major_code: major_code,
      }
      majorSubjectList(query).then((res) => {
        this.subjectsList = res.list || []
      })
    },
    formateSenior() {
      let arr = []
      this.senior.test_subject_codes.map((item) => {
        this.subjectsList.map((v) => {
          if (item == v.subject_code) {
            arr.push(v.subject_name)
          }
        })
      })

      // this.senior.test_subject_codes.forEach((item) => {
      //   arr.push(
      //     this.subjectsList.find((v) => {
      //       return v.subject_code === item //筛选出匹配数据
      //     }).subject_name
      //   )
      // })

      this.senior.test_subject_codes = this.senior.test_subject_codes.join(',')
      this.senior.test_subject_names = arr.join(',')
    },
  },
}
</script>

<style lang="less" scoped>
::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
}
::v-deep .el-upload--picture-card {
  width: 100px;
  height: 100px;
}
/* 穿透 scoped 样式，修改输入框边框 */
::v-deep .inptScore .el-input__inner {
  border: none; /* 去掉默认边框 */
  box-shadow: none; /* 去掉聚焦时的阴影（可选，根据需求） */
}
::v-deep .el-form-item--small .el-form-item__label {
  font-size: 12px;
}

/* 去掉聚焦状态的边框（避免点击后出现边框） */
::v-deep .inptScore .el-input__inner:focus {
  border: none;
  box-shadow: none;
}
.dialog-wrap {
  ::v-deep .el-dialog__header {
    background: #ecf2fe;
  }
  .senioBox {
    padding-left: 10px;
    display: flex;
    .footer {
      display: flex;
      justify-content: flex-end;
      .cancle {
        text-align: center;
        font-size: 14px;
        width: 56px;
        height: 36px;
        line-height: 36px;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #dcdfe6;
        margin-right: 10px;
      }
      .confirm {
        text-align: center;
        width: 56px;
        height: 36px;
        font-size: 14px;
        line-height: 36px;
        color: #fff;
        background: #1f86fe;
        border-radius: 4px 4px 4px 4px;
      }
    }
    .seniorItem {
      position: relative;
      width: 400px;
      border-right: 1px solid #dcdfe6;
      .invite {
        margin-left: -10px;
        margin-top: 12px;
        display: flex;
        align-items: center;
        font-weight: 700;
        font-size: 14px;
        color: #303133;

        .blue {
          margin-right: 6px;
          display: inline-block;
          width: 4px;
          height: 16px;
          background: #409eff;
          border-radius: 4px 4px 4px 4px;
        }
      }
      .edit {
        cursor: pointer;
        position: absolute;
        right: 30px;
        top: -10px;
        text-align: center;
        font-weight: 400;
        font-size: 14px;
        color: #409eff;
        width: 56px;
        height: 32px;
        line-height: 32px;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #409eff;
      }
      .userForm {
        width: 350px;
        margin-top: 14px;
      }
      .score {
        width: 180px;
        border-radius: 3px 3px 3px 3px;
        border: 1px solid #dddddd;
        margin-top: 10px;
        display: flex;
        height: 35px;
        position: relative;
        .preScore {
          font-size: 12px;
          position: absolute;
          right: 5px;
        }

        .subjectName {
          min-width: 100px;
          height: 35px;
          padding-left: 6px;
          padding-right: 6px;
          line-height: 35px;
          font-size: 10px;
          display: inline-block;
          background: #eeeeee;
          border-radius: 1px 0px 0px 1px;
        }
      }
    }
  }
  .submit {
    cursor: pointer;
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
    font-size: 14px;
    .cancle {
      text-align: center;
      width: 56px;
      height: 36px;
      line-height: 36px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #dcdfe6;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      margin-right: 18px;
    }
    .confirm {
      width: 56px;
      height: 36px;
      color: #fff;
      text-align: center;
      line-height: 36px;
      background: #1f86fe;
      border-radius: 4px 4px 4px 4px;
    }
  }
}
</style>
